import send from "@/utils/request";


//公司地址
export function resetPassword(params = {}) {
  return send({ url: '/ipp/v3/user/reset-password', method: 'POST', data: params });
}
